import React, { useState } from "react";
import Button from 'react-bootstrap/Button'
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  const [timers, setTimers] = useState([]);
  const [addButtonDisabled, setAddButtonDisabled] = useState(false);
  const [removeButtonDisabled, setRemoveButtonDisabled] = useState(false);

  function start(){
    setTimers([{
      "ID": 0,
      "timeStamp": new Date()
    }])
  }

  function addTimer(){
    const timer = {
      "ID": timers.length,
      "timeStamp": new Date()
    }

    setTimers([...timers, timer])

    setAddButtonDisabled(true);
    setTimeout(function() {
      setAddButtonDisabled(false);
    }, 500);
  }

  function removeTimer(){
    var tempArray = [...timers];
    tempArray.splice(-1,1);
    setTimers(
      tempArray
    )

    setRemoveButtonDisabled(true);
    setTimeout(function() {
      setRemoveButtonDisabled(false);
    }, 500);
  }

  function convertMs(ms) {
    const days = Math.floor(ms / (24*60*60*1000));
    const daysms=ms % (24*60*60*1000);
    const hours = Math.floor((daysms)/(60*60*1000));
    const hoursms=ms % (60*60*1000);
    const minutes = Math.floor((hoursms)/(60*1000));
    const minutesms=ms % (60*1000);
    const sec = Math.floor((minutesms)/(1000));
    return days+":"+hours+":"+minutes+":"+sec;
  }

  let month, date, year, hour, minute, second, formattedTotalTimeDiff;
  if (timers.length > 0) {
    [month, date, year]    = timers[0].timeStamp.toLocaleDateString("se-SE").split("/");
    [hour, minute, second] = timers[0].timeStamp.toLocaleTimeString("se-SE").split(/:| /);
    const totalTimeDiff = timers[timers.length-1].timeStamp - timers[0].timeStamp;
    formattedTotalTimeDiff = convertMs(totalTimeDiff);
  }

  return (
    <div className="content">
      <div className="menu">
        <div className="menu-text">
          { timers.length > 0 ? <div><p>Start time: </p><div className="time-taken-time">{year}{month}{date} {hour}:{minute}:{second}</div></div> : null } 
        </div>
        <Button variant="danger" className="menu-button" disabled={removeButtonDisabled} onClick={removeTimer}>-</Button>
        <Button className="menu-button" onClick={start}>Start</Button>
        <Button variant="success" className="menu-button" disabled={addButtonDisabled} onClick={addTimer}>+</Button>
        <div className="menu-text">
          { timers.length > 0 ? <div><p>Total time: </p><div className="time-taken-time">{formattedTotalTimeDiff}</div></div> : null }
        </div>
      </div>
      <div className="set-table">
        {timers.map((timer, i) => {
          if (i > 0) {
            const timeDiff = timer.timeStamp - timers[i-1].timeStamp;
            const formattedTimeDiff = convertMs(timeDiff);
            return(
              <div className="set" key={timer.ID}>
                <p>Set: {timer.ID}</p>
                <div className="time-taken-box">
                  <p className="time-taken-time">{formattedTimeDiff}</p>
                </div>
              </div>
            )
          }
          return null;
        })}
      </div>
    </div>
  );
}

export default App;
